import React from 'react';
import styled from 'styled-components';

const NormalBtnBlock = styled.button`
    height: ${props => props.height || '55px'};
    margin-top: ${props => props.marginTop || '5px'};
    margin-bottom: ${props => props.marginBottom || '0px'};
    margin-right: ${props => props.marginRight || '0px'};
    font-size: ${props => props.fontSize || '22px'};
    font-weight: ${props => props.fontWeight || '500'};
    border-radius: ${props => props.borderRadius || '4px'};
    color: ${props => props.textColor || '#fff'} ;
    background-color: ${props => props.bgColor || '#111'};
    background-image: url(${props => props.img || ''});
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid ${props => props.borderColor || props.bgColor || '#111'};
    width: ${props => props.width || '176px'};
    float: ${props => props.float || 'left'};
    min-width: ${props => props.minWidth || '100%'};
    line-height: ${props => props.lineHeight || 'normal'}; 
    padding: ${props => props.padding || '0'}; 
`;

const NormalBtn = ({ height, marginTop, marginBottom, marginRight, fontSize,
    fontWeight, width, minWidth, bgColor, textColor,
    borderRadius, float, text, img, lineHeight, padding, onClick, borderColor }) => {
    // console.log("img : " + img);
    return (
        <NormalBtnBlock
            height={height}
            marginTop={marginTop}
            marginRight={marginRight}
            marginBottom={marginBottom}
            fontSize={fontSize}
            fontWeight={fontWeight}
            borderRadius={borderRadius}
            bgColor={bgColor}
            textColor={textColor}
            width={width}
            minWidth={minWidth}
            lineHeight={lineHeight}
            float={float}
            img={img}
            padding={padding}
            onClick={onClick}
            borderColor={borderColor}>
            {text}
        </NormalBtnBlock>
    );
};

export default NormalBtn;